import { apiLic } from '@/api/api-lic.js'

const licMutations = {
    dealers_set(state, payload){
      state.dealers = payload;
    }
}

const licActions = {
  async dealer_list({commit}){
    const result = await apiLic.dealers();
    commit('dealers_set', result);
  },
}

export {
  licActions,
  licMutations
}